/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";

@Component({
    selector: "home",
    styleUrls: [
        "./vta.home.component.scss",
        "./assets/css/animate.css",
        "./assets/css/magnific-popup.css",
        "./assets/css/bootstrap-4.5.0.min.css",
        "./assets/css/slick.css",
        "./assets/css/LineIcons.2.0.css",
        "./assets/css/default.css",
        "./assets/css/style.css",
    ],
    templateUrl: "./vta.home.component.html",
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class HomeComponent implements OnInit {
  redirectDelay: number = 0;
  strategy: string = "";

  constructor(protected router: Router) {}
  ngOnInit(): void {}

  handleNavigation = (path: string) => {
    this.router.navigateByUrl(path);
  };
}
